import type { Column } from '@features/columns/models'
import { extractFkLabel } from '../../columns/logic/fkLabel'
import {
  formatColumnValue,
  shouldRenderBooleanAsCheckbox,
} from '../../columns/logic/displayFormats'

/**
 * Resolve the display text for a cell — the SAME string DataCell renders — so
 * the in-table find-on-page matcher highlights exactly what the user sees.
 *
 * - FK columns store a `{ label, id }` structure; we show the label.
 * - Editable checkbox-format booleans contribute no searchable text.
 * - Formula booleans render as read-only Yes/No text and remain searchable.
 */
export function resolveCellText(value: unknown, column: Column): string {
  if (value === null || value === undefined) return ''
  if (shouldRenderBooleanAsCheckbox(column)) return ''
  const fkParts = extractFkLabel(value)
  return fkParts ? fkParts.label : formatColumnValue(value, column)
}
